<template>
    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
        <div class="loader-wrap" v-if="show" :class="'type-' + showType">
            <Overlay :show="overlayShow" :opacity="0.3" :z-index="9998" ></Overlay>
            <div class="loader">
                <img src="@/assets/static/images/oval.svg">
                <span class="text c-grey-300">{{ text }}</span>
            </div>
        </div>
    </transition>
</template>

<script>
    import Overlay from '@/components/modal/overlay'
    
    export default {
        name: 'loader',
        props: {
            text: {
                type: String,
                default: '数据请求中'
            }
        },
        components: {
            Overlay
        },
        created () {
            this.$nextTick(() => {
                this.show = true
            })
        },
        methods: {
            showLoader () {
                const mainBody = this.mainBody()

                this.overlayShow = mainBody.type === 'modal' ? false : this.show

                mainBody.el.appendChild(this.$el)

                this.showType = mainBody.type
            },
            mainBody () {
                if (document.querySelector('.ui-modal')) {
                    return {
                        el: document.querySelector('.ui-modal'),
                        type: 'modal'
                    }
                } else if (document.querySelector('#mainContent')) {
                    return {
                        el: document.querySelector('#mainContent'),
                        type: 'content'
                    }
                } else {
                    return {
                        el: document.body,
                        type: 'body'
                    }
                }
            }
        },
        data () {
            return {
                show: false,
                overlayShow: false,
                showType: '',
                elInfo: {
                    width: 0,
                    height: 0,
                    top: 0,
                    left: 0
                }
            }
        },
        watch: {
            show (val, oldVal) {
                if (val === oldVal) { return false }

                if (val) {
                    this.showLoader()
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/loader/Loader.vue